import { DEFAULT_ERROR_MESSAGE } from '@/core/constants/error-messages';
import { ToastService } from '@/core/services/toast/toast.service';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

function extractBackendMessage(errorBody: unknown): string | null {
  if (typeof errorBody === 'string') {
    const message = errorBody.trim();
    return message.length > 0 ? message : null;
  }

  if (!errorBody || typeof errorBody !== 'object') {
    return null;
  }

  const body = errorBody as Record<string, unknown>;

  if (typeof body['message'] === 'string' && body['message'].trim()) {
    return body['message'].trim();
  }

  if (Array.isArray(body['message'])) {
    const messages = body['message']
      .filter((item): item is string => typeof item === 'string')
      .map((item) => item.trim())
      .filter(Boolean);
    if (messages.length) {
      return messages.join(', ');
    }
  }

  if (typeof body['error'] === 'string' && body['error'].trim()) {
    return body['error'].trim();
  }

  return null;
}

function resolveToastMessage(error: HttpErrorResponse): string {
  const backendMessage = extractBackendMessage(error.error);

  if (error.status === 0) {
    return 'Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.';
  }
  if (error.status === 401) {
    return 'Session expirée. Veuillez vous reconnecter.';
  }
  if (error.status === 403) {
    return "Accès refusé. Vous n'avez pas la permission.";
  }

  if (backendMessage) {
    console.error('[ERREUR]:' + backendMessage);
    return backendMessage;
  }

  if (error.status >= 500) {
    return 'Erreur serveur. Merci de réessayer plus tard.';
  }

  return error.message || DEFAULT_ERROR_MESSAGE;
}

export const httpErrorToastInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        toast.error(resolveToastMessage(error));
      } else {
        toast.error(DEFAULT_ERROR_MESSAGE);
      }

      return throwError(() => error);
    }),
  );
};
